export const MODELS_FETCH_STARTED = 'MODELS_FETCH_STARTED';
export const MODELS_FETCH_COMPLETED = 'MODELS_FETCH_COMPLETED';
export const MODELS_FETCH_FAILED = 'MODELS_FETCH_FAILED';
